import { useCallback } from 'react';

import { api } from '@shared/api';
import { UserStore } from '@shared/store';

import { MarginTransactionDirection } from '../../types';
import { useMarginAccount } from '../account';

const useMarginTransfer = () => {
  const { account } = useMarginAccount();
  const { getUniqueIdentifier } = UserStore.useUserStore;

  const transferToSpot = useCallback(
    async (amount: string) => {
      const data = { amount };
      const params = {
        swyftxUserId: getUniqueIdentifier(),
        traderAccountId: account?.traderAccountId,
      };

      return api.endpoints.withdrawFundsToSpot({ data, params });
    },
    [account?.traderAccountId, getUniqueIdentifier],
  );

  const transferToDerivatives = useCallback(
    async (amount: string) => {
      const data = { amount };
      const params = {
        swyftxUserId: getUniqueIdentifier(),
        traderAccountId: account?.traderAccountId,
      };

      return api.endpoints.depositFundsToDerivatives({ data, params });
    },
    [account?.traderAccountId, getUniqueIdentifier],
  );

  const transferFunds = useCallback(
    async (amount: string, transferTo: MarginTransactionDirection) => {
      if (transferTo === MarginTransactionDirection.Spot) {
        return transferToSpot(amount);
      } else {
        return transferToDerivatives(amount);
      }
    },
    [transferToDerivatives, transferToSpot],
  );

  return {
    transferFunds,
    transferToSpot,
    transferToDerivatives,
  };
};

export { useMarginTransfer };
